import styles from './sendMessage.module.scss'
import { SendIcon } from 'app/components/icons'

const SendMessage = ({ onClick, userInput, disabled }) => {
  return (
    <div className={styles.send_btn_wrapper}>
      <button onClick={onClick}>
        <SendIcon className={`${styles.send_icon} ${userInput ? styles.active_icon : ''}`} />
      </button>
    </div>
  )
}

export default SendMessage
